export const data = [
  {
    "region": "North Central",
    "total": 12926,
    "delivered": 2324,
    "in_transit": 4126,
    "BBDN": 2001,
    "to_be_invoiced": 4479
  },
  {
    "region": "North West",
    "total": 12926,
    "delivered": 2324,
    "in_transit": 4126,
    "BBND": 2001,
    "to_be_invoiced": 4479
  },
  {
    "region": "North East",
    "total": 12926,
    "delivered": 2324,
    "in_transit": 4126,
    "BBND": 2001,
    "to_be_invoiced": 4479
  },
  {
    "region": "West MAH",
    "total": 12926,
    "delivered": 2324,
    "in_transit": 4126,
    "BBND": 2001,
    "to_be_invoiced": 4479
  },
  {
    "region": "South 3C",
    "total": 12926,
    "delivered": 2324,
    "in_transit": 4126,
    "BBND": 2001,
    "to_be_invoiced": 4479
  },
  {
    "region": "Total",
    "total": 64630,
    "delivered": 11620,
    "in_transit": 20630,
    "BBND": 10005,
    "to_be_invoiced": 22395
  }
];


export const columns = ['Region', 'Total Ordered', 'Delivered', 'InTransit', 'BBND', 'To be invoiced'];
